import { fallBackEns } from './fallbackEnvs'

/** changed 2024 01 not to use destructuring for REACT_APP vars as React Native does not allow access except directly via process.env */
const env = process.env
const default_region: string = (env.AWS_DEFAULT_REGION as string) ?? (process.env.REACT_APP_AWS_DEFAULT_REGION as string) ?? fallBackEns.AWS_DEFAULT_REGION
const region = default_region
const accountId: string = (env.accountId as string) ?? (process.env.REACT_APP_AWS_ACCOUNT_ID as string) ?? fallBackEns.accountId
const projectCode: string = (env.projectCode as string) ?? (process.env.REACT_APP_PROJECT_CODE as string) ?? fallBackEns.projectCode
const appName: string = (env.projectName as string) ?? (process.env.REACT_APP_PROJECT_NAME as string) ?? fallBackEns.projectName
const stage: string = (env.EnvironmentParameter as string) ?? (process.env.REACT_APP_DEPLOYMENT_STAGE as string) ?? fallBackEns.stage

const resolvedEnvironmentVariables = {
  default_region,
  region,
  accountId,
  projectCode,
  appName,
  stage,
}

export { resolvedEnvironmentVariables }
